<ng-container
  *ngIf="{
    options: options$ | async,
    shipmentsRequest: shipmentsRequest$ | async,
  } as content"
>
  <div class="simple-card">
    <page-title></page-title>
  </div>

  <div class="simple-card m-t-20">
    <p class="m-b-12 h5">{{ 'shipment.form.instructions' | cxTranslate }}</p>

    <form [formGroup]="form" class="shipments-history__form" (submit)="submit()">
      <div class="row">
        <div class="col-12">
          <h6 class="d-block m-b-12">{{ 'formSearch.searchBy' | cxTranslate }}</h6>
          <div class="form-field-select">
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByOrderDate" class="form-check-input" formControlName="searchBy" value="orderDate" />
              <label class="form-check-label" for="searchByOrderDate">{{ 'shipment.form.orderDate' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByInvoice" class="form-check-input" formControlName="searchBy" value="invoiceNumber" />
              <label class="form-check-label" for="searchByInvoice">{{ 'formSearch.invoiceNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByPO" class="form-check-input" formControlName="searchBy" value="poNumber" />
              <label class="form-check-label" for="searchByPO">{{ 'formSearch.poNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByOrderNumber" class="form-check-input" formControlName="searchBy" value="orderNumber" />
              <label class="form-check-label" for="searchByOrderNumber">{{ 'formSearch.orderNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByPartNumber" class="form-check-input" formControlName="searchBy" value="partNumber" />
              <label class="form-check-label" for="searchByPartNumber">{{ 'formSearch.partNumber' | cxTranslate }}</label>
            </div>
          </div>
        </div>

        <ng-container *ngIf="form.get('searchBy')?.value !== 'orderDate'">
          <div class="col-12 col-md-4 m-t-16">
            <div class="form-group">
              <span>{{ 'formSearch.enterValue' | cxTranslate }}</span>
              <input
                type="text"
                class="form-control"
                formControlName="searchValue"
                placeholder="{{ 'formSearch.valuesInclude' | cxTranslate }}"
                (keydown.enter)="onEnter($event)"
              />
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="form.get('searchBy')?.value === 'orderDate'">
          <ng-container *ngIf="form.get('searchType')?.value !== 'custom'; else customDateRange">
            <div class="col-12 col-md-4 m-t-16">
              <div class="form-group">
                <span>{{ 'formSearch.selectDateRange' | cxTranslate }}</span>
                <select class="form-control" formControlName="searchType">
                  <option *ngFor="let item of options$ | async" [value]="item.code">
                    {{ item.label }}
                  </option>
                </select>
                <cx-form-errors [control]="form.get('searchType')"></cx-form-errors>
              </div>
            </div>
          </ng-container>

          <ng-template #customDateRange>
            <div class="col-12 col-md-4">
              <div class="form-group custom-date-picker">
                <div class="d-flex v-center m-b-4">
                  <button type="button" class="btn-back-search-type" (click)="backSearchType()">
                    <span class="material-symbols-outlined d-flex"> arrow_back_ios </span>
                  </button>
                  <label class="m-0" for="fromDate">{{ 'formSearch.from' | cxTranslate }}</label>
                </div>
                <p-datepicker
                  formControlName="fromDate"
                  dateFormat="mm/dd/yy"
                  showIcon="true"
                  inputStyleClass="form-control"
                  placeholder="..."
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  allowedKeysToDatePicker
                ></p-datepicker>
                <cx-form-errors [control]="form.get('fromDate')"></cx-form-errors>
              </div>
            </div>

            <div class="col-12 col-md-4">
              <div class="form-group custom-date-picker">
                <label for="toDate">{{ 'formSearch.to' | cxTranslate }}</label>
                <p-datepicker
                  formControlName="toDate"
                  dateFormat="mm/dd/yy"
                  showIcon="true"
                  inputStyleClass="form-control"
                  placeholder="..."
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  allowedKeysToDatePicker
                ></p-datepicker>
                <cx-form-errors [control]="form.get('toDate')"></cx-form-errors>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <div class="col-12">
          <div class="form-check">
            <label>
              <input type="checkbox" formControlName="openOnly" />
              <span class="form-check-label">{{ 'shipment.form.showOnlyOpenOrders' | cxTranslate }}</span>
            </label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <label>
              <input type="checkbox" formControlName="delayedOnly" />
              <span class="form-check-label">{{ 'shipment.form.showOnlyDelayedShipments' | cxTranslate }}</span>
            </label>
          </div>
        </div>

        <div class="w-100 col-12 form-button-container p-l-0">
          <div class="col-12 col-md-8 form-note">
            <span>{{ 'formSearch.note' | cxTranslate }}</span>
          </div>
          <div class="col-md-2 d-flex form-button">
            <button class="btn btn-outline-primary btn-sm w-100" (click)="clearAll()">
              {{ 'formSearch.clearAll' | cxTranslate }}
            </button>
          </div>
          <div class="col-md-2 d-flex form-button">
            <button type="submit" class="btn btn-primary btn-sm w-100">
              <span class="material-symbols-outlined d-flex m-r-4"> search </span>
              {{ 'formSearch.search' | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-container *ngIf="!content.shipmentsRequest?.isPristine">
    <div class="simple-card m-t-20">
      <ng-container *ngIf="!content.shipmentsRequest?.isLoading; else loading">
        <ng-container *ngIf="content.shipmentsRequest?.shipments?.length; else noShipments">
          <table-pro [configs]="tableConfig">
            <div top-action-2>
              <button type="button" class="btn btn-secondary btn-sm w-100" (click)="exportShipments()">
                <span class="material-symbols-outlined d-flex m-r-4"> download </span>
                {{ 'exportEntries.exportToExcel' | cxTranslate }}
              </button>
            </div>
            <table class="table-responsive table-md">
              <thead>
                <tr>
                  <th>{{ 'shipment.table.header.orderNumber' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.orderDate' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.expShipDate' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.actualShipDate' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.poNumber' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.tracking' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.invoiceNumber' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.partNumber' | cxTranslate }}</th>
                  <th>{{ 'shipment.table.header.qtyOrdered' | cxTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let shipment of content.shipmentsRequest?.shipments">
                  <tr *ngFor="let item of shipment.items">
                    <td [attr.data-value]="shipment.orderNumber">
                      <div class="d-flex">
                        <span class="responsive-title m-r-4">{{ 'shipment.table.header.orderNumber' | cxTranslate }}:</span>

                        <a [routerLink]="['/my-account/order', shipment.orderUid]" class="text-underline">
                          {{ shipment.orderNumber }}
                        </a>
                      </div>
                    </td>
                    <td [attr.data-value]="shipment.orderDate">
                      <span class="responsive-title">{{ 'shipment.table.header.orderDate' | cxTranslate }}:</span>
                      {{ shipment.orderDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <td [attr.data-value]="shipment.shipDate">
                      <span class="responsive-title">{{ 'shipment.table.header.expShipDate' | cxTranslate }}:</span>
                      {{ shipment.shipDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <td [attr.data-value]="shipment.actualShipDate">
                      <span class="responsive-title">{{ 'shipment.table.header.actualShipDate' | cxTranslate }}:</span>
                      {{ shipment.actualShipDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <td [attr.data-value]="shipment.poNumber">
                      <span class="responsive-title">{{ 'shipment.table.header.poNumber' | cxTranslate }}:</span>
                      {{ shipment.poNumber }}
                    </td>
                    <td [attr.data-value]="shipment.trackingNumber">
                      <span class="responsive-title">{{ 'shipment.table.header.tracking' | cxTranslate }}:</span>
                      <ng-container *ngIf="shipment.trackingInfo; else noLink">
                        <a [href]="shipment.trackingInfo" target="_blank" class="text-underline">
                          {{ shipment.trackingNumber }}
                        </a>
                      </ng-container>
                      <ng-template #noLink>
                        {{ shipment.trackingNumber }}
                      </ng-template>
                    </td>
                    <td [attr.data-value]="item.invoiceNumber">
                      <span class="responsive-title">{{ 'shipment.table.header.invoiceNumber' | cxTranslate }}:</span>
                      <a [routerLink]="['/my-account/invoice', item.invoiceUid]" class="text-underline" target="_blank">
                        {{ item.invoiceNumber }}
                      </a>
                    </td>
                    <td [attr.data-value]="item.partNumber">
                      <span class="responsive-title">{{ 'shipment.table.header.partNumber' | cxTranslate }}:</span>
                      {{ item.partNumber }}
                    </td>
                    <td [attr.data-value]="item.quantityOrdered">
                      <span class="responsive-title">{{ 'shipment.table.header.qtyOrdered' | cxTranslate }}:</span>
                      {{ item.quantityOrdered }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </table-pro>
        </ng-container>
        <ng-template #noShipments>
          <p class="text-center ff-bold m-0">{{ 'shipment.noShipmentsAvailable' | cxTranslate }}</p>
        </ng-template>
      </ng-container>
      <ng-template #loading>
        <local-loader></local-loader>
      </ng-template>
    </div>
  </ng-container>
</ng-container>
